module.exports = __webpack_public_path__ + "img/Weapon_258.89bc077b.png";